import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

const SuccessPage = () => {
  const [sessionId, setSessionId] = useState('');
  const [emailStatus, setEmailStatus] = useState('pending'); // 'pending', 'sent', 'error'
  const [emailSent, setEmailSent] = useState(false); // Flag to track if email has been sent
  const location = useLocation();
  const navigate = useNavigate();
  
  useEffect(() => {
    // Only proceed if we haven't sent an email yet
    if (emailSent) return;
    
    const queryParams = new URLSearchParams(location.search);
    const session_id = queryParams.get('session_id');
    
    if (session_id) {
      setSessionId(session_id);
      setEmailSent(true); // Set flag to prevent duplicate calls
      
      const apiUrl = process.env.REACT_APP_BACKEND_URL || 'http://localhost:3002';
      
      fetch(`${apiUrl}/api/payment-success`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ session_id }),
      })
      .then(response => {
        if (!response.ok) {
          throw new Error(`Email sending failed: ${response.status}`);
        }
        return response.json();
      })
      .then(data => {
        console.log('Email sent successfully:', data);
        setEmailStatus('sent');
      })
      .catch(error => {
        console.error('Error sending confirmation email:', error);
        setEmailStatus('error');
        setEmailSent(false); // Reset flag if there was an error to allow retry
      });
    } else {
      console.error('No session_id found in URL');
      setEmailStatus('error');
    }
  }, [location.search, emailSent]); // Only depend on location.search and emailSent flag

  const handleContinueShopping = () => {
    navigate('/');
  };

  return (
    <div className="flex font-display items-center justify-center h-screen">
      <div className="bg-white p-6 rounded-lg shadow-2xl text-center relative w-10/12 md:w-1/2">
        <button className="transform flex items-center justify-center w-8 h-8 bg-[#27D152] mx-auto text-[#3E1D9E] font-bold rounded-full">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke="#FFFFFF"
            className="w-6 h-6"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M5 13l4 4L19 7"
            />
          </svg>
        </button>
        <div className="mt-4 text-base font-bold">Thank You</div>
        <div className="text-base font-bold">Your payment is successfully done</div>
        
        {/* Show email status */}
        {emailStatus === 'pending' && (
          <div className="text-sm text-blue-600 mt-2">
            Sending confirmation email...
          </div>
        )}
        {emailStatus === 'sent' && (
          <div className="text-sm text-green-600 mt-2">
            A confirmation email has been sent to your inbox
          </div>
        )}
        {emailStatus === 'error' && (
          <div className="text-sm text-red-600 mt-2">
            Unable to send confirmation email. Please contact support.
          </div>
        )}
        
        <button 
          onClick={handleContinueShopping}
          className="mt-4 px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
        >
          Done
        </button>
      </div>
    </div>
  );
};

export default SuccessPage;